import { Injectable } from '@angular/core';
import { Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Comune, StaticUrls } from '../models';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { Cap } from '../models/cap';
import { AuthHttp } from 'angular2-jwt';

@Injectable()
export class CapService {

	private capList: Cap[];
	private headers = new Headers({ 'Content-Type': 'application/json' });
	private options = new RequestOptions({ headers: this.headers });

	constructor(private http: AuthHttp) { }

	get(comuni: Comune[]): Observable<Cap[]> {
		return this.http.post(StaticUrls._getCapByComuni, JSON.stringify(comuni), this.options)
			.map(this.handleResponse)
			.catch(this.handleError);
	}

	check(cap: string, comune: string): Observable<boolean> {
		return this.http.get(StaticUrls._capCheck(cap, comune), this.options)
			.map(response => {
				if (response.status === 200) { return true; }
				else { return false; }
			})
			.catch(this.handleError);
	}

	private handleResponse(response: Response) {
		this.capList = response.json();
		return this.capList;
	}

	private handleError(error: Response | any) {
		let errMsg: string;

		if (error instanceof Response) {
			const body = error.json() || '';
			const err = body.error || JSON.stringify(body);
			errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
		}
		else {
			errMsg = error.message ? error.message : error.toString();
		}
		return Observable.throw(errMsg);
	}
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/services/cap.service.ts